import React, { lazy, Suspense } from 'react';
import { useRouteLoaderData } from 'react-router-dom';
import PasswordAndSettingsSkeletonLayout from '../../components/PasswordAndSettingsSkeletonLayout';
import { StorybookClient } from '../../mocks/StorybookClient';
import ProtectedPageWrapper from '../../shared/ProtectedPageWrapper';

const PasswordAndSecurity = lazy(() =>
	import('../../components/PasswordAndSecurity')
);

const PasswordAndSettingsAddPhoneMultiStepForm = lazy(() =>
	import('../../components/PasswordAndSettingsAddPhoneMultiStepForm')
);
const PasswordAndSettingsEmailMultiStepForm = lazy(() =>
	import('../../components/PasswordAndSettingsEmailMultiStepForm')
);
const PasswordAndSettingsEnterPassword = lazy(() =>
	import(
		'../../components/PasswordAndSettingsEnterPassword/PasswordAndSettingsEnterPassword'
	)
);

const DataFetchingWrapper = () => {
	const { hasOwnProvider } = useRouteLoaderData('identity');
	return hasOwnProvider ? (
		<ProtectedPageWrapper />
	) : (
		// Only add the QueryClientProvider if the consuming app doesn't have it.
		<StorybookClient>
			<ProtectedPageWrapper />
		</StorybookClient>
	);
};

const PasswordAndSettingsRoutes = [
	{
		path: 'password-and-settings',
		element: <DataFetchingWrapper />,
		children: [
			{
				index: true,
				element: (
					<Suspense
						fallback={
							<PasswordAndSettingsSkeletonLayout mainComponent={false} />
						}
					>
						<PasswordAndSecurity />
					</Suspense>
				),
			},
			{
				path: 'password-and-settings-enter-password',
				element: (
					<Suspense fallback={<PasswordAndSettingsSkeletonLayout />}>
						<PasswordAndSettingsEnterPassword />
					</Suspense>
				),
			},
			{
				path: 'multi-factor-add-phone-number',
				element: (
					<Suspense fallback={<PasswordAndSettingsSkeletonLayout />}>
						<PasswordAndSettingsAddPhoneMultiStepForm />
					</Suspense>
				),
			},
			{
				path: 'multi-factor-email-address',
				element: (
					<Suspense fallback={<PasswordAndSettingsSkeletonLayout />}>
						<PasswordAndSettingsEmailMultiStepForm />
					</Suspense>
				),
			},
		],
	},
];

export default PasswordAndSettingsRoutes;
